import collection from "@/store/collection.store-partial";
import hintModule from "@/store/game/hints/single.store";

export default {
	namespaced: true,
	modules: {
		collection,
	},
	getters: {
		active: (state, getters) => getters.array.find((hint) => hint.active),
	},
	actions: {
		configureApp: {
			root: true,
			async handler({ dispatch }, configData) {
				await dispatch("createHook", {
					type: "add",
					handler: (collectionContext, hint) => collectionContext.dispatch(`${hint.id}/listen`),
				});

				await dispatch("populate", {
					items: configData.hints,
					path: ["game", "hints"],
					module: hintModule,
				});
			},
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/game/hints/list.store.js